!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : "object" == typeof exports ? exports.AccountKit = e(require("react")) : t.AccountKit = e(t.react);
}(this, function (t) {
  return function (t) {
    function e(o) {
      if (n[o]) return n[o].exports;
      var r = n[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return t[o].call(r.exports, r, r.exports, e), r.l = !0, r.exports;
    }

    var n = {};
    return e.m = t, e.c = n, e.i = function (t) {
      return t;
    }, e.d = function (t, n, o) {
      e.o(t, n) || Object.defineProperty(t, n, {
        configurable: !1,
        enumerable: !0,
        get: o
      });
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(n, "a", n), n;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 5);
  }([function (t, e, n) {
    "use strict";

    function o(t) {
      return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function r(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var o = e[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
      }
    }

    function u(t, e, n) {
      return e && i(t.prototype, e), n && i(t, n), t;
    }

    function c(t, e) {
      return !e || "object" !== o(e) && "function" != typeof e ? s(t) : e;
    }

    function a(t) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function s(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function p(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && f(t, e);
    }

    function f(t, e) {
      return (f = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function l(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function d(t, e) {
      !function (e) {
        var n = document.createElement("script");
        n.setAttribute("src", "https://sdk.accountkit.com/".concat(t.language, "/sdk.js")), n.setAttribute("id", "account-kit"), n.setAttribute("type", "text/javascript"), n.onload = e, document.head.appendChild(n);
      }(function () {
        window.AccountKit_OnInteractive = function () {
          var n = t.appId,
              o = t.csrf,
              r = t.version,
              i = t.debug,
              u = t.display,
              c = t.redirect;
          window.AccountKit.init({
            appId: n,
            state: o,
            version: r,
            debug: i,
            display: u,
            redirect: c,
            fbAppEventsEnabled: !1
          }), e();
        };
      });
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var y = n(4),
        b = n.n(y),
        h = n(2),
        m = (n.n(h), function (t) {
      function e() {
        var t, n;
        r(this, e);

        for (var o = arguments.length, i = new Array(o), u = 0; u < o; u++) {
          i[u] = arguments[u];
        }

        return n = c(this, (t = a(e)).call.apply(t, [this].concat(i))), l(s(n), "state", {
          initialized: !!window.AccountKit
        }), l(s(n), "onLoad", function () {
          n.mounted && n.setState({
            initialized: !0
          });
        }), l(s(n), "signIn", function () {
          if (!n.state.disabled) {
            var t = n.props,
                e = t.loginType,
                o = t.onResponse,
                r = t.countryCode,
                i = t.phoneNumber,
                u = t.emailAddress,
                c = {};
            r && (c.countryCode = r), "PHONE" === e && i ? c.phoneNumber = i : "EMAIL" === e && u && (c.emailAddress = u), window.AccountKit.login(e, c, function (t) {
              return o(t);
            });
          }
        }), n;
      }

      return p(e, t), u(e, [{
        key: "componentDidMount",
        value: function value() {
          this.mounted = !0, this.state.initialized || d({
            appId: this.props.appId,
            csrf: this.props.csrf,
            version: this.props.version,
            debug: this.props.debug,
            display: this.props.display,
            redirect: this.props.redirect,
            language: this.props.language
          }, this.onLoad);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.mounted = !1;
        }
      }, {
        key: "render",
        value: function value() {
          var t = this,
              e = !this.state.initialized || this.props.disabled;
          return this.props.children({
            onClick: function onClick() {
              t.signIn();
            },
            disabled: e
          });
        }
      }]), e;
    }(b.a.Component));
    m.defaultProps = {
      debug: !1,
      disabled: !1,
      display: "popup",
      language: "en_US",
      loginType: "PHONE"
    }, e.default = m;
  }, function (t, e, n) {
    "use strict";

    function o() {}

    var r = n(3);

    t.exports = function () {
      function t(t, e, n, o, i, u) {
        if (u !== r) {
          var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw c.name = "Invariant Violation", c;
        }
      }

      function e() {
        return t;
      }

      t.isRequired = t;
      var n = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e
      };
      return n.checkPropTypes = o, n.PropTypes = n, n;
    };
  }, function (t, e, n) {
    t.exports = n(1)();
  }, function (t, e, n) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    t.exports = n(0);
  }]);
});